import { useState } from "react";
import { Link } from "react-router-dom";
import { resolveImagePath } from "@/utils/imageMap.ts";

const navLinks = [
  { label: "Home", href: "/" },
  { label: "Glider Rides", href: "/general-8" },
  { label: "Training", href: "/services-4" },
  { label: "Contact", href: "/contact-3" },
];

export function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const logoSrc = resolveImagePath("/images/logo.png");

  return (
    <header className="absolute top-0 left-0 right-0 z-50 flex items-center justify-between px-4 py-2">
      <a href="/" className="flex items-center">
        <img
          src={logoSrc}
          alt="Merlin Aviation"
          width={203}
          height={153}
          className="object-contain"
          style={{ maxHeight: "76px", width: "auto" }}
        />
      </a>

      <button
        type="button"
        aria-label="Open menu"
        onClick={() => setMenuOpen(true)}
        className="flex items-center justify-center w-10 h-10 rounded-full bg-white bg-opacity-80 hover:bg-opacity-100 transition-colors"
      >
        <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect y="0" width="20" height="2" fill="#1e2025" />
          <rect y="7" width="20" height="2" fill="#1e2025" />
          <rect y="14" width="20" height="2" fill="#1e2025" />
        </svg>
      </button>

      {menuOpen && (
        <div className="fixed inset-0 z-50 bg-white flex flex-col" role="dialog" aria-modal="true">
          <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
            <a href="/" onClick={() => setMenuOpen(false)}>
              <img
                src={logoSrc}
                alt="Merlin Aviation"
                width={100}
                height={75}
                className="object-contain"
              />
            </a>
            <button
              type="button"
              aria-label="Close menu"
              onClick={() => setMenuOpen(false)}
              className="text-gray-700 hover:text-gray-900 text-2xl font-light"
            >
              ✕
            </button>
          </div>
          <nav className="flex-1 flex items-center justify-center">
            <ul className="flex flex-col gap-6 text-center">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    onClick={() => setMenuOpen(false)}
                    className="font-heading text-2xl text-[#1e2025] hover:text-[#50556a] transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      )}
    </header>
  );
}
